
import {defineComponent, onMounted} from "vue";
import Economic from "../components/Economic.vue";
import {setPageHeader} from "@/core/helpers/toolbar";

export default defineComponent({
    components: {
        Economic
    },
    setup() {
        onMounted(() => {
            setPageHeader({
                title: 'message.ECONOMIC',
                actionButton: null,
                breadCrumbs: [
                    { name: "message.HOME", link: "/dashboard"},
                    { name: "message.ECONOMIC", link: "#"},
                    { name: "message.ECONOMIC"}
                ]
            })
        })
    }
});
    
